import React, { useState } from "react";
import {
  Input,
  Form,
  Button,
  Row,
  Col,
  Tooltip,
  Space,
  Checkbox,
  Cascader,
  Spin,
  Table,
  Select,
  Collapse,
  message,
  Upload,
  InputNumber,
} from "antd";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import {
  AntdFormItem,
  AntdInput,
  AntdInputNumber,
  AntdInputSelect,
  AntdSwitch,
  AntdTextArea,
  AntdUpload,
} from "./Component/Component";
import { useMutation, useQuery } from "@tanstack/react-query";
import { product_getMarketplaces } from "services/dataservice";
import { product_getCategories } from "services/dataservice";
import { convertDataToTree, loadBrandOptions, loadInventoryOptions } from "./common";
import { yupResolver } from "@hookform/resolvers/yup";
import { productValidation } from "./product-schema";
import { product_create } from "services/dataservice";
import styles from "./Style/index.module.less";
import { product_getAttributes } from "services/dataservice";
import SelectAsync from "react-select/async";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./Style/editor.css";
import { product_variant_get } from "services/dataservice";
import NewForm from "./NewForm";
import { product_getCustomAttributes } from "services/dataservice";
import { product_brands_get } from "services/dataservice";
import { ControlledSortableUploader } from "./Component/ControlledSortableUploader";
import CustomComboBox from "./Component/CustomComboBox";

const detailsDefaultValue = [
  {
    variant: "NoVariation",
    marketplaceSKU: "",
    name: "",
    sellingPrice: 0,
    costPrice: 0,
    variations: [],
    images: [],
    sizeChart: [],
    weight: "",
  },
];

export default function ProductTest() {
  //const [data, setData] = useState("");
  const history = useHistory();
  const form = useForm({
    values: {
      name: "",
      parentSKU: "",
      description: "",
      isVariant: false,
      isSingleVariant: false,
      isDraft: false,
      images: [],
      sizeChart: [],
      details: detailsDefaultValue,
      variations: [],
      packageWeight: 0,
      packageLength: 0,
      packageWidth: 0,
      packageHeight: 0,
      magento: {
        select: false,
        category: [],
        color: "",
        news_from_date: "",
        news_to_date: "",
        material: "",
        size: "",
        type: [],
        short_description: "",
        seo: {
          url_key: "",
          meta_title: "",
          meta_keyword: "",
          meta_description: "",
        },
        opacity: "",
        texture: "",
        thickness: "",
        note: "",
        sizeChart: {
          size_chart_inch: "",
          size_chart_cm: "",
        },
        materialCare: {
          material_care: "",
        },
        relatedProducts: [],
      },
    },
    resolver: yupResolver(productValidation),
    mode: "onChange",
  });
  const {
    control,
    formState: { errors },
    watch,
    setValue,
    trigger,
    getValues,
  } = form;
  const [
    parentSKU,
    name,
    description,
    isVariant,
    details,
    variations,
    images,
    magento,
    magentoSelect,
    isSingleVariant,
  ] = watch([
    "parentSKU",
    "name",
    "description",
    "isVariant",
    "details",
    "variations",
    "images",
    "magento",
    "magento.select",
    "isSingleVariant",
  ]);

  const { fields, append, remove } = useFieldArray({
    name: "variations",
    control,
  });

  const { fields: detailsFields } = useFieldArray({
    name: "details",
    control,
  });
  const [userMarketplace, setUserMarketplace] = useState(null);
  const [attributesRequest, setAttributesRequest] = useState(null);
  //const [variants, setVariants] = useState([]);
  const [customAttributes, setCustomAttributes] = useState({});

  const [marketplacesCategories, setMarketplacesCategories] = useState([]);
  const [categories, setCategories] = useState({});
  const [categories2, setCategories2] = useState({});
  const [brands, setBrands] = useState([]);

  const [showCostPrice, setShowCostPrice] = useState(false);

  const { isFetching: isMarketplacesFetching } = useQuery({
    queryKey: ["product-marketplaces"],
    queryFn: () => product_getMarketplaces(),
    onSuccess: (data) => {
      setMarketplacesCategories(
        data.data.data.map((d) => ({ ...d, categoryId: "0", selected: false, attributes: [] }))
      );
    },
    onError: () => {},
  });
  const { isFetching: isCategoriesFetching } = useQuery({
    queryKey: ["product-categories", { userMarketplace }],
    queryFn: () => product_getCategories({ userMarketplaceId: userMarketplace.userMarketplaceId }),
    enabled: Boolean(userMarketplace),
    onSuccess: (data) => {
      let clone = categories;
      clone[userMarketplace.marketplaceId] = convertDataToTree(data.data.data);
      console.log(convertDataToTree(data.data.data));
      setCategories(clone);
      let clone2 = categories2;
      clone2[userMarketplace.marketplaceId] = data.data.data;
      setCategories2(clone2);
    },
    onError: () => {},
  });
  // useQuery({
  //   queryKey: ["product-variants"],
  //   queryFn: () => product_variant_get(),
  //   onSuccess: (data) => {
  //     setVariants(data.data.data);
  //   },
  //   onError: (data) => {},
  // });
  const { isFetching: isAttributesFetching } = useQuery({
    queryKey: ["product-attributes", { attributesRequest }],
    queryFn: () =>
      product_getAttributes({
        marketplaceId: attributesRequest.marketplaceId,
        categoryId: attributesRequest.categoryId,
      }),
    enabled: Boolean(attributesRequest),
    onSuccess: (data) => {
      setMarketplacesCategories(
        marketplacesCategories.map((x) => {
          if (x.userMarketplaceId === attributesRequest.userMarketplaceId) {
            x.attributes = data.data.data;
          }
          return x;
        })
      );
    },
    onError: (data) => {},
  });
  const { isFetching: isBrandsFetching } = useQuery({
    queryKey: ["product-brands"],
    queryFn: () => product_brands_get(),
    enabled: Boolean(attributesRequest),
    onSuccess: (data) => {
      setBrands(data.data.data);
    },
    onError: (data) => {},
  });
  useQuery({
    queryKey: ["product-custom-attributes", { attributesRequest }],
    queryFn: () =>
      product_getCustomAttributes({
        marketplaceId: attributesRequest.marketplaceId,
        userMarketplaceId: attributesRequest.userMarketplaceId,
      }),
    enabled: Boolean(attributesRequest),
    onSuccess: (data) => {
      const temp = data.data.data;
      setCustomAttributes({ ...temp, category: convertDataToTree(temp?.category ?? []) });
    },
    onError: (data) => {},
  });
  const createMutation = useMutation(product_create, {
    onError: (data) => {
      message.error(data.response.data.message);
    },
  });
  const createStatus = createMutation.status === "loading";

  const onFinish = async () => {
    // if (!Boolean(data)) {
    //   setValue("description", "");
    // } else {
    //   setValue("description", data);
    // }
    const isValid = await trigger();
    if (!isValid) {
      message.error("Please fill up the required field");
      return;
    }

    if (!marketplacesCategories.some((x) => x.selected === true)) {
      message.error("Marketplaces Categories is required, please select at least 1 marketplace");
      return;
    }

    if (marketplacesCategories.filter((x) => x.selected === true).some((x) => x.categoryId === 0)) {
      message.error("Categories is required");
      return;
    }

    if (
      marketplacesCategories
        .filter((x) => x.selected === true)
        .some((x) =>
          x.attributes.filter((a) => a.isMandatory === true).some((a) => Boolean(a.value) === false)
        )
    ) {
      message.error("Attributes is required");
      return;
    }

    if (isVariant && getValues("details").some((x) => x.images.length === 0)) {
      message.error("SKU Images is required");
      return;
    }

    if (isVariant && magentoSelect === true && !Boolean(getValues("parentSKU"))) {
      message.error("Parent SKU is required for Magento");
      return;
    }

    if (!isVariant && magentoSelect === true && !Boolean(getValues("magento.color"))) {
      message.error("Color is required");
      return;
    }

    const { sizeChart, images, ...values } = getValues();
    if (
      isVariant &&
      isSingleVariant &&
      values.variations.length === 2 &&
      values.variations[1].values.length > 1
    ) {
      message.error("Invalid size variation, single variation can have only 1 option");
      return;
    }
    const marketplaces = marketplacesCategories.filter((x) => x.selected === true);
    const req = {
      ...values,
      marketplaces,
    };

    const detailsImages = isVariant
      ? values.details.map((x) => {
          const arr = x.images[0].name.split(".");
          return {
            marketplaceSKU: x.marketplaceSKU,
            fileName: `${x.marketplaceSKU}.${arr[arr.length - 1]}`,
            images: x.images,
          };
        })
      : [];
    const info = {
      details: detailsImages.map((x) => ({
        marketplaceSKU: x.marketplaceSKU,
        fileName: x.fileName,
      })),
    };

    let formData = new FormData();
    formData.append("data", JSON.stringify(req));
    formData.append("info", JSON.stringify(info));
    images.forEach((image) => {
      formData.append("images", image.originFileObj);
    });
    sizeChart.forEach((image) => {
      formData.append("sizeChart", image.originFileObj);
    });
    detailsImages.forEach((image) => {
      formData.append("variationImages", image.images[0].originFileObj, image.fileName);
    });
    createMutation.mutate(formData, {
      onSuccess: () => {
        message.success("Success");
        history.push("/admin/product/list");
      },
    });
  };

  const [editorTextAreaShow, SetEditorTextAreaShow] = useState(false);

  return (
    <div className="content">
      <Spin
        tip="Loading"
        spinning={
          isMarketplacesFetching ||
          isCategoriesFetching ||
          isAttributesFetching ||
          isBrandsFetching ||
          createStatus
        }
      >
        {/* {JSON.stringify(magento)} */}
        <Form onFinish={onFinish}>
          <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
            <Collapse.Panel header="Product Information" key="1">
              <AntdFormItem
                labelCol={{ span: 24 }}
                label="Name"
                errors={errors["name"]}
                required={true}
              >
                <AntdInput control={control} name="name" />
              </AntdFormItem>

              <Controller
                name={"description"}
                control={control}
                render={({ field }) => (
                  <AntdFormItem
                    labelCol={{ span: 24 }}
                    label="Description"
                    errors={errors["description"]}
                    required={true}
                  >
                    <Button
                      type="success"
                      onClick={() => {
                        SetEditorTextAreaShow(!editorTextAreaShow);
                        //setValue("description", "");
                      }}
                    >
                      Show / Hide Editor
                    </Button>
                    {editorTextAreaShow === false ? (
                      <ReactQuill
                        theme="snow"
                        onChange={(v) => {
                          field.onChange(v);
                        }}
                        value={field.value}
                      />
                    ) : (
                      // <ReactQuill theme="snow" onChange={setData} value={data} />
                      <AntdTextArea
                        autoSize={{ minRows: 10 }}
                        control={control}
                        name="description"
                      />
                    )}
                  </AntdFormItem>
                )}
              />

              {/* <Form.Item required={true} label="Upload Images">
                <AntdUpload multiple={true} control={control} name="images" />
              </Form.Item> */}

              <Form.Item required={true} label="Upload Images">
                <ControlledSortableUploader control={control} name="images" />
              </Form.Item>

              <Form.Item label="Upload Size Chart Image">
                <AntdUpload control={control} name="sizeChart" />
              </Form.Item>

              <Form.Item label="Draft">
                <AntdSwitch control={control} name="isDraft" />
              </Form.Item>
            </Collapse.Panel>
          </Collapse>

          <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
            <Collapse.Panel header="Variations" key="1">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Variation">
                    <AntdSwitch
                      control={control}
                      name="isVariant"
                      onChange={(v) => {
                        setValue("isVariant", v);
                        if (v === true) {
                          setValue("details", []);
                          setValue("variations", [
                            { name: "Color Family", values: [] },
                            { name: "Size", values: [] },
                          ]);
                        } else {
                          setValue("details", detailsDefaultValue);
                          setValue("variations", []);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                {isVariant && (
                  <Col span={12}>
                    <Form.Item label="Single Variation">
                      <AntdSwitch
                        control={control}
                        name="isSingleVariant"
                        onChange={(v) => {
                          setValue("isSingleVariant", v);
                        }}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>

              {isVariant && (
                <div style={{ marginTop: "-2rem" }}>
                  <AntdFormItem
                    labelCol={{ span: 24 }}
                    label="Parent SKU"
                    errors={errors["parentSKU"]}
                    required={magentoSelect && isVariant}
                  >
                    <SelectAsync
                      placeholder="Search SKU"
                      cacheOptions
                      loadOptions={loadInventoryOptions}
                      onChange={(v) => {
                        setValue(`parentSKU`, Boolean(v) ? v.inventorySKU : "");
                      }}
                      isClearable
                    />
                  </AntdFormItem>
                </div>
              )}

              {isVariant && (
                <div>
                  <Row gutter={16}>
                    {fields.map((field, index) => (
                      <Col span={12} key={field.id}>
                        <AntdFormItem
                          label={
                            <div>
                              <span style={{ margin: "0 10px 0 0" }}>Variation {index + 1}</span>
                            </div>
                          }
                          labelCol={{ span: 24 }}
                          errors={errors.variations?.[index]?.name}
                        >
                          <span style={{ fontWeight: "bold" }}>Variation Name</span>
                          <AntdInput
                            control={control}
                            name={`variations.${index}.name`}
                            placeholder="e.g. Color"
                            disabled={true}
                          />
                        </AntdFormItem>
                        <AntdFormItem errors={errors.variations?.[index]?.values}>
                          <span style={{ fontWeight: "bold" }}>
                            {index === 0 ? "Color Family" : "Size"}
                          </span>
                          <AntdInputSelect
                            mode="tags"
                            open={false}
                            control={control}
                            name={`variations.${index}.values`}
                            placeholder={`${index === 0 ? "e.g. Red" : "e.g. XL"}`}
                            //options={variants[index].options}
                          />
                        </AntdFormItem>
                      </Col>
                    ))}
                  </Row>
                  <Space>
                    {/* <Button
                      type="primary"
                      onClick={() => append({ name: "", values: [] })}
                      disabled={fields.length > 1}
                    >
                      Add Variation
                    </Button> */}

                    <Button
                      type="primary"
                      onClick={async () => {
                        //const isValid = await trigger("variations");
                        //if (!isValid) return;
                        const variations = getValues("variations");
                        if (variations.every((x) => x.values.length === 0)) {
                          message.error("Variation is required");
                          return;
                        }
                        if (variations.some((x) => x.values.length === 0)) {
                          let oneIndex = variations.findIndex((x) => x.values.length > 0);
                          const details = variations[oneIndex].values.map((v) => {
                            return {
                              variant: v,
                              marketplaceSKU: "",
                              name: "",
                              sellingPrice: 0,
                              costPrice: 0,
                              variations: [{ name: variations[oneIndex].name, value: v }],
                              images: [],
                            };
                          });
                          setValue("details", details);
                        } else {
                          const details = variations[0].values.flatMap((v) =>
                            variations[1].values.map((x) => {
                              return {
                                variant: `${v}/${x}`,
                                marketplaceSKU: "",
                                name: "",
                                sellingPrice: 0,
                                costPrice: 0,
                                variations: [
                                  { name: variations[0].name, value: v },
                                  { name: variations[1].name, value: x },
                                ],
                                images: [],
                              };
                            })
                          );
                          setValue("details", details);
                        }
                      }}
                    >
                      Create Variation
                    </Button>
                  </Space>
                  {detailsFields.length > 0 && (
                    <div>
                      <Table
                        columns={[
                          {
                            title: "Color Group",
                            dataIndex: "variant",
                            key: "variant",
                            width: "10%",
                          },
                          {
                            ...(isVariant && {
                              title: "Images",
                              dataIndex: "images",
                              key: "images",
                              render: (_, e) => {
                                return (
                                  <Controller
                                    name={`details.${e.index}.images`}
                                    control={control}
                                    render={({ field }) => (
                                      <AntdFormItem errors={errors.details?.[e.index]?.images}>
                                        <Upload
                                          beforeUpload={() => false}
                                          onChange={(file) => {
                                            if (file.fileList.length === 0) {
                                              field.onChange([]);
                                              return;
                                            }
                                            const isValid = file.fileList.some((x) => {
                                              return x.size / 1024 / 1024 > 1;
                                            });
                                            if (isValid) {
                                              message.error("image size cannot greater than 1mb");
                                              return;
                                            }
                                            field.onChange(file.fileList);
                                          }}
                                          className={styles.upload}
                                          fileList={field.value}
                                          listType="picture-card"
                                          accept=".jpg,.jpeg,.png"
                                        >
                                          {field.value.length > 0 ? null : <PlusOutlined />}
                                        </Upload>
                                      </AntdFormItem>
                                    )}
                                  />
                                );
                              },
                            }),
                          },
                        ]}
                        dataSource={detailsFields.map((field, index) => ({
                          index: index,
                          key: field.id,
                          variant: field.variant,
                        }))}
                      />
                    </div>
                  )}
                </div>
              )}
            </Collapse.Panel>
          </Collapse>

          <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
            <Collapse.Panel header="Marketplaces SKUs" key="1">
              {detailsFields.length > 0 && (
                <div>
                  <Table
                    columns={[
                      { title: "Variant", dataIndex: "variant", key: "variant", width: "10%" },
                      {
                        title: "Marketplace SKU",
                        dataIndex: "marketplaceSKU",
                        key: "marketplaceSKU",
                        width: "25%",
                        render: (_, e) => {
                          return (
                            <AntdFormItem errors={errors.details?.[e.index]?.marketplaceSKU}>
                              <SelectAsync
                                placeholder="Search SKU"
                                cacheOptions
                                loadOptions={loadInventoryOptions}
                                onChange={(v) => {
                                  setValue(`details.${e.index}.marketplaceSKU`, v.inventorySKU);
                                  setValue(`details.${e.index}.name`, v.name);
                                  setValue(`details.${e.index}.sellingPrice`, v.sellingPrice);
                                  setValue(`details.${e.index}.costPrice`, v.costPrice);
                                  setValue(`details.${e.index}.weight`, v.weight);
                                  console.log(v.weight);
                                }}
                              />
                            </AntdFormItem>
                          );
                        },
                      },
                      {
                        title: "Name",
                        dataIndex: "name",
                        key: "name",
                        width: "25%",
                        render: (_, e) => {
                          return (
                            <div className={styles.input}>
                              <AntdFormItem errors={errors.details?.[e.index]?.name}>
                                <AntdInput control={control} name={`details.${e.index}.name`} />
                              </AntdFormItem>
                            </div>
                          );
                        },
                      },
                      {
                        title: "Cost Price",
                        dataIndex: "costPrice",
                        key: "costPrice",
                        width: "10%",
                        render: (_, e) => {
                          return (
                            <AntdFormItem errors={errors.details?.[e.index]?.costPrice}>
                              <AntdInputNumber
                                control={control}
                                name={`details.${e.index}.costPrice`}
                              />
                            </AntdFormItem>
                          );
                        },
                      },
                      {
                        title: "Selling Price",
                        dataIndex: "sellingPrice",
                        key: "sellingPrice",
                        width: "10%",
                        render: (_, e) => {
                          return (
                            <AntdFormItem errors={errors.details?.[e.index]?.sellingPrice}>
                              <AntdInputNumber
                                control={control}
                                name={`details.${e.index}.sellingPrice`}
                              />
                            </AntdFormItem>
                          );
                        },
                      },
                      {
                        title: "Weight Length Width Height",
                        dataIndex: "weight",
                        key: "weight",
                        width: "20%",
                        render: (_, e) => {
                          return (
                            <AntdFormItem errors={errors.details?.[e.index]?.weight}>
                              <AntdInput
                                control={control}
                                name={`details.${e.index}.weight`}
                                disabled={true}
                              />
                            </AntdFormItem>
                          );
                        },
                      },
                    ].filter((x) => showCostPrice || x.key !== "costPrice")}
                    dataSource={detailsFields.map((field, index) => ({
                      index: index,
                      key: field.id,
                      variant: field.variant,
                      marketplaceSKU: field.marketplaceSKU,
                      name: field.name,
                      sellingPrice: field.sellingPrice,
                      costPrice: field.costPrice,
                      weight: field.weight,
                    }))}
                  />
                </div>
              )}
            </Collapse.Panel>
          </Collapse>

          <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
            <Collapse.Panel header="Marketplaces Categories" key="1">
              {marketplacesCategories.map((m, index) => {
                let selectType = null;
                if (m.categoryRequired === true) {
                  if (m.selectType === "CASCADER") {
                    selectType = (
                      <Cascader
                        placeholder="Search Category"
                        style={{ width: "100%" }}
                        size="large"
                        options={categories[m.marketplaceId] ?? []}
                        allowClear={false}
                        showSearch={(v, o) => {
                          o.some((x) => x.toLowerCase().indexOf(v.toLowerCase()));
                        }}
                        onChange={(v, o) => {
                          console.log(v);
                          console.log(o);
                          let clone = marketplacesCategories;
                          clone[index].categoryId = o[o.length - 1]?.id;
                          clone[index].categories = v;
                          setMarketplacesCategories(clone);
                          setAttributesRequest({
                            userMarketplaceId: clone[index].userMarketplaceId,
                            marketplaceId: clone[index].marketplaceId,
                            categoryId: clone[index].categoryId,
                          });
                        }}
                      />
                    );
                  } else {
                    selectType = (
                      <Select
                        placeholder="Search Category"
                        size="large"
                        showSearch
                        options={categories2[m.marketplaceId] ?? []}
                        filterOption={(input, option) =>
                          (option.label ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                        onChange={(v, e) => {
                          let clone = marketplacesCategories;
                          clone[index].categoryId = e.id;
                          clone[index].categories = [e.id];
                          setMarketplacesCategories(clone);
                          setAttributesRequest({
                            userMarketplaceId: clone[index].userMarketplaceId,
                            marketplaceId: clone[index].marketplaceId,
                            categoryId: clone[index].categoryId,
                          });
                        }}
                      />
                    );
                  }
                }
                return (
                  <Form.Item key={index}>
                    <Checkbox
                      onChange={(e) => {
                        if (categories[m.marketplaceId] === undefined) {
                          setUserMarketplace({
                            userMarketplaceId: m.userMarketplaceId,
                            marketplaceId: m.marketplaceId,
                          });
                          if (m.categoryRequired === false) {
                            setAttributesRequest({
                              userMarketplaceId: m.userMarketplaceId,
                              marketplaceId: m.marketplaceId,
                              categoryId: m.categoryId,
                            });
                          }
                        }
                        let clone = marketplacesCategories;
                        clone[index].selected = e.target.checked;
                        //console.log(clone);
                        setMarketplacesCategories(clone);
                        if (m.platformName === "MagentoV2") {
                          setValue("magento.select", e.target.checked);
                        }
                        setShowCostPrice(
                          marketplacesCategories.some(
                            (x) =>
                              (x.platformName === "ShopifyV2" || x.platformName === "Shopify") &&
                              x.selected === true
                          )
                        );
                      }}
                    >
                      {m.name}
                    </Checkbox>
                    {selectType}

                    {m.selected && m.platformName !== "MagentoV2" && (
                      <Collapse defaultActiveKey={["1"]}>
                        <Collapse.Panel header="Attributes" key="1">
                          <Row gutter={16}>
                            {m.brandRequired && (
                              <Col span={6}>
                                <Form.Item label="Brands" labelCol={{ span: 24 }} required>
                                  {/* <SelectAsync
                                    placeholder="Search Brand"
                                    cacheOptions
                                    loadOptions={(e, v) =>
                                      loadBrandOptions(e, v, m.categoryId, m.platformName)
                                    }
                                    onChange={(v) => {
                                      console.log(v.value);
                                      let clone = marketplacesCategories;
                                      clone[index].brandId = v.value;
                                      setMarketplacesCategories(clone);
                                    }}
                                  /> */}
                                  <Select
                                    size="large"
                                    options={brands
                                      .filter((x) => x.platformName === m.platformName)
                                      .map((x) => ({ label: x.name, value: x.brandId }))}
                                    onChange={(v, e) => {
                                      let clone = marketplacesCategories;
                                      clone[index].brandId = e.value;
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                            )}

                            {m.attributes.map((x, i) => {
                              let input = null;
                              if (x.inputType === "Text") {
                                input = (
                                  <Input
                                    size="large"
                                    type="text"
                                    onChange={(e) => {
                                      let clone = marketplacesCategories;
                                      clone[index].attributes[i].value = e.target.value;
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              } else if (x.inputType === "Textarea") {
                                input = (
                                  <Input.TextArea
                                    onChange={(e) => {
                                      let clone = marketplacesCategories;
                                      clone[index].attributes[i].value = e.target.value;
                                      console.log(clone[index].attributes[i].value);
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              } else if (x.inputType === "Number") {
                                let addonAfter = x.unit?.type;
                                input = (
                                  <InputNumber
                                    style={{ width: "100%" }}
                                    onChange={(v) => {
                                      let clone = marketplacesCategories;
                                      clone[index].attributes[i].value = v;
                                      setMarketplacesCategories(clone);
                                    }}
                                    precision={2}
                                    size="large"
                                    min={0}
                                    addonAfter={
                                      addonAfter === null ? null : (
                                        <Select
                                          style={{ width: 100 }}
                                          onChange={(v) => {
                                            let clone = marketplacesCategories;
                                            clone[index].attributes[i].UnitValue = v;
                                            setMarketplacesCategories(clone);
                                          }}
                                        >
                                          {x.unit?.type?.length > 0 &&
                                            x.unit.type.map((t) => (
                                              <Select.Option key={t} value={t}>
                                                {t}
                                              </Select.Option>
                                            ))}
                                        </Select>
                                      )
                                    }
                                  />
                                );
                              } else if (x.inputType === "SingleSelect") {
                                input = (
                                  <Select
                                    size="large"
                                    options={x.options}
                                    onChange={(v, e) => {
                                      console.log(v);
                                      let clone = marketplacesCategories;
                                      clone[index].attributes[i].value = v;
                                      clone[index].attributes[i].values = [e];
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              } else if (x.inputType === "MultiSelect") {
                                input = (
                                  <Select
                                    mode="multiple"
                                    size="large"
                                    options={x.options}
                                    filterOption={(input, option) =>
                                      (option.label ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    onChange={(v, e) => {
                                      console.log(v);
                                      let clone = marketplacesCategories;
                                      clone[index].attributes[i].value = v.join(",");
                                      clone[index].attributes[i].values = e;
                                      console.log(clone[index].attributes[i]);
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              } else if (x.inputType === "MultiComboBox") {
                                input = (
                                  <Select
                                    mode="tags"
                                    size="large"
                                    value={x.value ? x.value.split(",") : []}
                                    options={x.options}
                                    filterOption={(input, option) =>
                                      (option.label ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    onChange={(v, e) => {
                                      // let clone = marketplacesCategories;
                                      // clone[index].attributes[i].value = v.join(",");
                                      // clone[index].attributes[i].values = e;
                                      // console.log(clone[index].attributes[i]);
                                      // setMarketplacesCategories(clone);
                                      if (x.max !== 0 && e.length > x.max) {
                                        message.error(`cannot select more than ${x.max} option`);
                                        return;
                                      }
                                      const clone = [...marketplacesCategories];
                                      const clone1 = { ...clone[index].attributes[i] };
                                      clone1.value = v.join(",");
                                      clone1.values = e;
                                      clone[index].attributes[i] = clone1;
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              } else if (x.inputType === "CustomComboBox") {
                                input = (
                                  <CustomComboBox
                                    value={x.value ? x.value.split(",") : []}
                                    options={x.options ?? []}
                                    type={x.unit?.type ?? []}
                                    precision={x.unit?.precision ?? 0}
                                    onChange={(v, e) => {
                                      if (e.length > x.max) {
                                        message.error(`cannot select more than ${x.max} option`);
                                        return;
                                      }
                                      const clone = [...marketplacesCategories];
                                      const clone1 = { ...clone[index].attributes[i] };
                                      clone1.value = v.join(",");
                                      clone1.values = e;
                                      clone[index].attributes[i] = clone1;
                                      //console.log(clone[index].attributes[i]);
                                      setMarketplacesCategories(clone);
                                    }}
                                  />
                                );
                              }

                              return (
                                <Col span={6} key={i}>
                                  <Form.Item
                                    label={x.label}
                                    labelCol={{ span: 24 }}
                                    required={x.isMandatory}
                                  >
                                    {input}
                                  </Form.Item>
                                </Col>
                              );
                            })}
                          </Row>
                        </Collapse.Panel>
                      </Collapse>
                    )}

                    {m.selected && m.platformName === "MagentoV2" && (
                      <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
                        <Collapse.Panel header="Attributes" key="1">
                          <NewForm
                            variations={variations}
                            isVariant={isVariant}
                            customAttributes={customAttributes}
                            control={control}
                            errors={errors}
                          />
                        </Collapse.Panel>
                      </Collapse>
                    )}
                  </Form.Item>
                );
              })}
            </Collapse.Panel>
          </Collapse>

          <Collapse style={{ marginBottom: "10px" }} defaultActiveKey={["1"]}>
            <Collapse.Panel header="Shipping" key="1">
              <Row gutter={16}>
                <Col span={6}>
                  <AntdFormItem
                    labelCol={{ span: 24 }}
                    label="Package Weight (kg)"
                    errors={errors["packageWeight"]}
                    required={true}
                  >
                    <AntdInputNumber control={control} name="packageWeight" />
                  </AntdFormItem>
                </Col>
                <Col span={6}>
                  <AntdFormItem
                    labelCol={{ span: 24 }}
                    label="Package Length (cm)"
                    errors={errors["packageLength"]}
                    required={true}
                  >
                    <AntdInputNumber control={control} name="packageLength" />
                  </AntdFormItem>
                </Col>
                <Col span={6}>
                  <AntdFormItem
                    labelCol={{ span: 24 }}
                    label="Package Width (cm)"
                    errors={errors["packageWidth"]}
                    required={true}
                  >
                    <AntdInputNumber control={control} name="packageWidth" />
                  </AntdFormItem>
                </Col>
                <Col span={6}>
                  <AntdFormItem
                    labelCol={{ span: 24 }}
                    label="Package Height (cm)"
                    errors={errors["packageHeight"]}
                    required={true}
                  >
                    <AntdInputNumber control={control} name="packageHeight" />
                  </AntdFormItem>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>

          <Form.Item style={{ textAlign: "center" }}>
            <Button htmlType="submit">Submit</Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
}
